import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';


import {
  AppLayoutComponent,
  AuthGuard,
  LoginComponent,
  NotfoundComponent,
  RegisterComponent,
} from 'shared';







@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          component: AppLayoutComponent,
          children: [
            {
              path: '',
              data: { breadcrumb: 'Προφίλ' },
              loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'calendar',
              data: { breadcrumb: 'Ημερολόγιο​' },
              loadComponent: () => import('./pages/calendar/calendar.component').then(m => m.CalendarComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'manage-patients',
              data: { breadcrumb: 'Βάση Επισκεπτών' },
              loadComponent: () => import('./pages/manage-patients/manage-patients.component').then(m => m.ManagePatientsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'patient-details/:id',
              data: { breadcrumb: '' },
              loadComponent: () => import('./pages/manage-patients/patient-details/patient-details.component').then(m => m.PatientDetailsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'manage-visits',
              data: { breadcrumb: 'Βάση Επισκέψεων' },
              loadComponent: () => import('./pages/manage-visits/manage-visits.component').then(m => m.ManageVisitsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'manage-doctors',
              data: { breadcrumb: 'Βάση Ιατρών' },
              loadComponent: () => import('./pages/manage-doctors/manage-doctors.component').then(m => m.ManageDoctorsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'manage-exams',
              data: { breadcrumb: 'Βάση Εξετάσεων' },
              loadComponent: () => import('./pages/manage-exams/manage-exams.component').then(m => m.ManageExamsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'prescription-details/:id',
              data: { breadcrumb: '' },
              loadComponent: () => import('./pages/prescription-referral/prescription-details/prescription-details.component').then(m => m.PrescriptionDetailsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'prescriptions',
              data: { breadcrumb: 'Συνταγογράφηση / Παραπεμπτικό' },
              loadComponent: () => import('./pages/prescription-referral/prescription-referral.component').then(m => m.PrescriptionReferralComponent),
              canActivate: [AuthGuard],
            },
          ],
        },
        {
          path: 'notfound',
          component: NotfoundComponent,
          canActivate: [AuthGuard],
        },
        { path: 'login', component: LoginComponent },
        { path: 'register', component: RegisterComponent },
        { path: '**', redirectTo: '/notfound' },
      ],
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload',
      }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
